<div class="machines_performance_wrapper mb-5">
  <h3>
    <span class="fw-semibold">{{ 'TABLE.DETAILS.performances.MISSIONS' | translate }}: </span>
    @if (machinePerformanceDetails.length < 1) {
      <span class="fw-normal">{{ 'DATA_NOT_AVAILABLE' | translate }}</span>
    }
    @if (machinePerformanceDetails.length > 0 && selectedFilterName) {
      <span class="fw-normal">{{
        selectedFilterName
      }}</span>
    }
  </h3>
  <hr />

  @if (machinePerformanceDetails.length > 0) {
    <div class="info-and-chart-container">
      <div class="info-container">
        <div class="missions-detail mb-3">
          <div class="mission-data">
            <h4 class="picking fw-bold">
              {{ maxPickingMissions }}
            </h4>
            <app-icam-icon iconName="arrow-picking" [iconHeight]="'12px'" [iconColor]="pickingColor" [isDefault]="true" />
          </div>
          <p class="my-0 py-0 text">
            {{ 'TABLE.DETAILS.performances.picking_missions' | translate }}
          </p>
        </div>
        <div class="missions-detail">
          <div class="mission-data">
            <h4 class="refilling fw-bold">
              {{ maxRefillingMissions }}
            </h4>
            <app-icam-icon
              iconName="arrow-refilling"
              [iconHeight]="'12px'"
              [iconColor]="refillingColor"
              [isDefault]="true"
              />
          </div>
          <p class="my-0 py-0 text">
            {{ 'TABLE.DETAILS.performances.refilling_missions' | translate }}
          </p>
        </div>
      </div>
      <div id="chartContainer">
        <canvas baseChart [type]="'line'" [data]="lineChartData" [options]="lineChartOptions" [legend]="false"></canvas>
        <div class="legend-container">
          <div class="legend">
            <div class="text">
              {{ 'TABLE.DETAILS.performances.picking_missions' | translate }}
            </div>
            <div class="legend-line picking"></div>
          </div>
          <div class="legend">
            <div class="text">
              {{ 'TABLE.DETAILS.performances.refilling_missions' | translate }}
            </div>
            <div class="legend-line refilling"></div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
